export type OtpPreference = "EMAIL" | "TOTP";

export const OTP_PREFERENCE_EMAIL: OtpPreference = "EMAIL";
export const OTP_PREFERENCE_TOTP: OtpPreference = "TOTP";
export const DEFAULT_OTP_PREFERENCE: OtpPreference = OTP_PREFERENCE_TOTP;

export const PENDING_OTP_PREFERENCE_KEY = "pending_otp_preference";

export const OTP_PREFERENCE_LABELS: Record<OtpPreference, string> = {
  EMAIL: "Email verification code",
  TOTP: "Authenticator app",
};

export const normalizeOtpPreference = (value: unknown): OtpPreference | null => {
  if (value === "EMAIL" || value === "email") return OTP_PREFERENCE_EMAIL;
  if (value === "TOTP" || value === "totp") return OTP_PREFERENCE_TOTP;
  return null;
};
